import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validator for phone numbers with format (00) 0000-0000
export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    if (!value) {
      return null; // If the value is empty, return null (no error)
    }
    const isValid = value.length === 14; // "(00) 0000-0000" has 14 characters
    return isValid ? null : { phoneInvalid: true };
  };
}

// Validator for mobile phone numbers with format (00) 00000-0000
export function mobilePhoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    if (!value) {
      return null; // If the value is empty, return null (no error)
    }
    const isValid = value.length === 15; // "(00) 00000-0000" has 15 characters
    return isValid ? null : { mobilePhoneInvalid: true };
  };
}

// Validator for both phone and mobile phone numbers
export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    if (!value) {
      return null; // If the value is empty, return null (no error)
    }

    // Remove non-digit characters
    const numericValue = value.replace(/\D/g, '');

    // Validate based on number of digits (10 for house, 11 for mobile)
    const isValidPhone = numericValue.length === 10; // (00) 0000-0000
    const isValidMobile = numericValue.length === 11; // (00) 00000-0000

    // Return null if valid, otherwise return the validation error
    return isValidPhone || isValidMobile ? null : { phoneNumberInvalid: true };
  };
}
